<template>
    <transition name="fade">
        <div v-if="isOpen" class="streaks-player">
            <div class="streaks-player-mask">
                <div class="streaks-player-modal">
                    <div class="streaks">
                        <button class="close-button"
                                @click="close">×</button>
                        <video-player ref="videoPlayer"
                                      :is-play-button="false"
                                      :mediaId="name"
                                      :options="{
                                        controls: true,
                                        preload: 'none',
                                        fluid: true,
                                        autoplay: true
                                      }">
                        </video-player>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
export default {
    name: "StreaksPlayer",
    components: {VideoPlayer},
    data: function () {
        return {
            name: null,
            isOpen: false,
            isHideCloseButton: false,
            videoUrl: `${process.env.VUE_APP_VIDEO_URL}`,
        }
    },
    methods: {
        open: function (name) {
            this.name = name;
            this.isOpen = true;
        },
        close: function () {
            this.isOpen = false;
        },
        displayCloseButton: function () {
            this.isHideCloseButton = false;
        },
        hideCloseButton: function () {
            this.isHideCloseButton = true;
        }
    }
}
</script>

<style src="./StreaksPlayer.scss" lang="scss" />
